import React, { useContext, useRef, useEffect, useState } from "react";
import { SimpleTooltip, SimpleUtility } from "simple-ui-components";

import DriveEtaIcon from "@mui/icons-material/DriveEta";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import { LanguageContext, getTranslation } from "../languageProvider";
import { Layout, useWindowSize } from "../layout/otherPage";
import {
  BodyWrapperStyled,
  BoxStyled,
  CardHeader,
  CardBody,
  CardStyled,
  OuterWrapper,
  EmptyList,
} from "../../theme";
import { AddEditVehicles } from "./addEditVehicle";
import { del, get } from "../../server-requests/serverRequests";
import { AuthContext } from "../authContextProvider";
import { Log, ReplaceWord } from "../shared/utility";
import { LoadingList } from "../shared/loading";
import VehicleDetail from "./vehicleDetail";
import DeletePopup from "../shared/deletePopup";

const Vehicles = () => {
  const { Tooltip } = SimpleTooltip;
  const { UpdateObject } = SimpleUtility;

  const addEditVehicleRef = useRef();
  const deleteVehicleRef = useRef();

  const { lang } = useContext(LanguageContext);
  const { snackbarHandler } = useContext(AuthContext);

  const { wrapperHeight, boxHeight } = useWindowSize();

  const [vehicles, setVehicles] = useState({
    isLoading: true,
    list: [],
    reload: true,
  });

  useEffect(() => {
    if (vehicles.reload) {
      get("vehicles/list")
        .then((data) => {
          setVehicles((prev) =>
            UpdateObject(prev, {
              isLoading: false,
              reload: false,
              list: data,
            })
          );
        })
        .catch((status) => {
          snackbarHandler(getTranslation(`error${status}`));
          setVehicles((prev) =>
            UpdateObject(prev, {
              isLoading: false,
              reload: false,
            })
          );
          Log("Error: get vehicles" + status);
        });
    }
  }, [vehicles.reload, UpdateObject, snackbarHandler]);

  const addVehicleClickHandler = () => addEditVehicleRef.current.Update("add");
  const editVehicleClickHandler = (vehicle) =>
    addEditVehicleRef.current.Update("edit", vehicle);

  const deleteVehicleClickHandler = (id) => {
    deleteVehicleRef.current.Delete(
      id,
      `${getTranslation("0032")} ${getTranslation("0172").toLowerCase()}`,
      ReplaceWord(
        getTranslation("0120"),
        "**NAME**",
        getTranslation("0172").toLowerCase()
      )
    );
  };

  const deleteVehicleHandler = (vehicle) => {
    del("vehicles", {
      id: vehicle.id,
    })
      .then(() => {
        snackbarHandler(
          ReplaceWord(
            getTranslation("0121"),
            "**NAME**",
            getTranslation("0172")
          ),
          "success"
        );
        setVehicles((prev) =>
          UpdateObject(prev, {
            isLoading: true,
            reload: true,
          })
        );
      })
      .catch((status) => {
        snackbarHandler(getTranslation(`error${status}`));
        Log("Error on delete vehicle" + status);
      });
  };

  const updateVehiclesSuccessHandler = () =>
    setVehicles((prev) =>
      UpdateObject(prev, {
        isLoading: true,
        reload: true,
      })
    );

  let listElement = null;
  if (vehicles.isLoading) {
    listElement = <LoadingList count={5} />;
  } else {
    if (vehicles.list.length === 0) {
      listElement = (
        <EmptyList data-translate="0049,0123">
          {ReplaceWord(
            getTranslation("0123"),
            "**NAME**",
            getTranslation("0172").toLowerCase()
          )}
        </EmptyList>
      );
    } else {
      listElement = vehicles.list.map((vehicle) => (
        <VehicleDetail
          key={vehicle.id}
          vehicle={vehicle}
          Edit={editVehicleClickHandler}
          Delete={deleteVehicleClickHandler}
        />
      ));
    }
  }

  return (
    <Layout lang={lang}>
      <OuterWrapper height={wrapperHeight}>
        <BodyWrapperStyled fullHeight>
          <BoxStyled noMargin>
            <CardStyled>
              <CardHeader>
                <DriveEtaIcon className="mainIcon" />
                <div className="detail" data-translate="0173">
                  {getTranslation("0173")}
                  <span data-translate="0173">
                    {ReplaceWord(
                      getTranslation("0078"),
                      "**NUMBER**",
                      vehicles.list.length,
                      "**LISTNAME**",
                      getTranslation("0173").toLowerCase()
                    )}
                  </span>
                </div>
                <Tooltip
                  text={`${getTranslation("0087")} ${getTranslation(
                    "0172"
                  ).toLowerCase()}`}
                  placement="left"
                >
                  <AddOutlinedIcon onClick={addVehicleClickHandler} />
                </Tooltip>
              </CardHeader>
              <CardBody height={boxHeight}>{listElement}</CardBody>
            </CardStyled>
          </BoxStyled>
        </BodyWrapperStyled>
        <AddEditVehicles
          ref={addEditVehicleRef}
          Update={updateVehiclesSuccessHandler}
        />
        <DeletePopup
          ref={deleteVehicleRef}
          DeleteSuccess={deleteVehicleHandler}
        />
      </OuterWrapper>
    </Layout>
  );
};

export default Vehicles;
